/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchOrdersViewModel } from '../../models/search-orders-view-model';

export interface SearchOrders$Params {
  workCenterId: number;
  ShowFinished?: boolean | null;
  ShowOpen?: boolean | null;
  ShowActive?: boolean | null;
  ShowEnded?: boolean | null;
  ExternalProductionOrderIdFilter?: string | null;
}

export function searchOrders(http: HttpClient, rootUrl: string, params: SearchOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SearchOrdersViewModel>>> {
  const rb = new RequestBuilder(rootUrl, searchOrders.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.query('ShowFinished', params.ShowFinished, {});
    rb.query('ShowOpen', params.ShowOpen, {});
    rb.query('ShowActive', params.ShowActive, {});
    rb.query('ShowEnded', params.ShowEnded, {});
    rb.query('ExternalProductionOrderIdFilter', params.ExternalProductionOrderIdFilter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SearchOrdersViewModel>>;
    })
  );
}

searchOrders.PATH = '/api/v1/ProductionOrder/{workCenterId}/SearchOrders';
